import { Moment } from 'moment'
import { NamedItem, NamedItemInt } from '../../domain/common/namedItem'
import { adminHttpClient } from '../commons/adminHttpClient'
import { CompanyType } from '../../domain/benefit/companyType'
import { EmploymentStatus } from '../adminDashboard/managePeople/enums/employmentStatus'
import { isEmployeeEligibleForProductClass } from './isEmployeeEligible'

export type EmployeeForSaveDto = {
  companyUserId?: string
  firstName: string
  lastName: string
  workPhone?: string
  workEmail: string
  personalEmail?: string
  hireDate?: Moment
  employmentStatus?: EmploymentStatus
  familyStatusId?: number
  identificationNumber?: string
  benefitEligibilityDate?: Moment
  productClassId?: string
  renewalProductClassId?: string
  currentCompanyTypeId: CompanyType
  productClasses: ProductClassForEmployeeForSave[]
  renewalProductClasses: ProductClassForEmployeeForSave[]
  familyStatuses: NamedItem[]
  employmentStatuses: NamedItemInt[]
  benefitStartDate: Moment
  benefitEndDate: Moment
  latestBenefitHistoryEffectiveDate?: Moment
  latestFamilyStatusEffectiveDate?: Moment
  availableStates: NamedItem[]
  receiveSms: boolean
  hasBenefitStarted: boolean
  canEditBenefitData: boolean
  allowProductClassSelection: boolean
  birthDay?: string
  notificationDate?: string
  requireBirthDate: boolean
  showEmployeeNotificationDate: boolean
  isEmployeeNotificationDateEditable: boolean
  currentBenefitHistoryStartDate?: string
  maxNotificationDate?: string
  minNotificationDate?: string
  planPeriodId: string
  stateOfResidenceId?: string
  zipCode?: string
}

export type ProductClassForEmployeeForSave = {
  id: string
  name: string
  allowedEligibilityStatuses: EmploymentStatus[]
}

export const filterProductClassesByEmploymentStatus = (
  productClasses: ProductClassForEmployeeForSave[],
  newEmploymentStatus: EmploymentStatus,
  companyTypeId: CompanyType,
) => {
  const resultClasses: ProductClassForEmployeeForSave[] = []
  productClasses.forEach((x) => {
    if (isEmployeeEligibleForProductClass(newEmploymentStatus, companyTypeId, x)) {
      resultClasses.push(x)
    }
  })
  return resultClasses
}

export const getEmployeeForSave = (id = null): Promise<EmployeeForSaveDto> => {
  const url = id ? `/Companies/EmployeeForSave/${id}` : `/Companies/EmployeeForSave`
  return adminHttpClient.get(url)
}

export const getCompleteAdminProfileForSave = (id: string): Promise<EmployeeForSaveDto> => {
  return adminHttpClient.get(`/Companies/CompleteAdminProfileForSave/${id}`)
}
